export default {
  dashboard: "Dashboard",
  attachments: {
    submit: "Submit",
    reset: "Reset",
    choose_file: "Choose File",
    drag: "Drag & drop a PNG here, or click below to browse",
    attachments: "Attachments",
  },
};
